import { useMemo } from "react";
import { RankLoyalty } from "types/Loyalty";
import LoyaltyCircleProgress from "components/atoms/LoyaltyCircleProgress";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";
import { calcProgressPercent, formatLevels } from "./utils";

export type LoyaltyRankProgressbarProps = {
  rank: RankLoyalty;
  nextRank?: RankLoyalty;
  userExperience: number;
};

const LoyaltyRankProgressbar = (props: LoyaltyRankProgressbarProps) => {
  const { rank, nextRank, userExperience } = props;
  const t = useTranslate();
  const levels = useMemo(
    () =>
      formatLevels({
        t,
        rank,
        nextRank,
        userExperience,
      }),
    [t, rank, nextRank, userExperience],
  );

  const progress = useMemo(
    () =>
      calcProgressPercent({
        userExperience,
        currentRank: rank,
        nextRank,
      }),
    [userExperience, rank, nextRank],
  );

  return (
    <div className="LoyaltyRankProgressbar">
      <div className="LoyaltyRankProgressbar__levels">
        {levels.map((level) => (
          <span key={level.required} className="LoyaltyRankProgressbar__name">
            {level.name}
          </span>
        ))}
      </div>
      <div className="LoyaltyRankProgressbar__circles">
        {levels.map((level) => (
          <LoyaltyCircleProgress key={level.required} variant={level.variant} />
        ))}
      </div>
      <div className="LoyaltyRankProgressbar__progressbar">
        <div
          className="LoyaltyRankProgressbar__progress"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default LoyaltyRankProgressbar;
